import moment from 'moment';

export const datasLimites = {
    dataInicial: new Date(new Date().getFullYear() - 1, 0, 1),
    dataFinal: new Date(new Date().getFullYear() + 3, 11, 31, 23, 59, 59),
};

function normalizarData(data?: Date | moment.Moment | string | null, formato?: string): moment.Moment | null {
    if (!data) {
        return null;
    }

    if (moment.isMoment(data)) {
        return data.clone();
    }

    if (typeof data === 'string') {
        const formatos = formato ? [formato, moment.ISO_8601] : [moment.ISO_8601];
        const dataMoment = moment(data, formatos, true);
        return dataMoment.isValid() ? dataMoment : null;
    }

    const dataMoment = moment(data);
    return dataMoment.isValid() ? dataMoment : null;
}

export function calcularDataLimiteCalendario(
    dataLimiteFinal: Date | null,
    usaSla: boolean,
    dataFechamentoStr: string | null
) {

    if (!usaSla) { return dataLimiteFinal; }

    const dataFechamento = dataFechamentoStr
        ? moment(dataFechamentoStr, 'YYYY-MM-DD').toDate()
        : null;

    if (!dataLimiteFinal) { return dataFechamento; }
    if (!dataFechamento) { return dataLimiteFinal; }

    return dataLimiteFinal < dataFechamento ? dataLimiteFinal : dataFechamento;
}

export function calcularDataFechamentoSlaPorMes(
    dataReferencia: Date | moment.Moment | string | null,
    usaSla: boolean,
    fechamentoCalendario: string,
    calendarioFechaProximoMes: boolean,
    formatoEntrada?: string
): Date | null {
    if (!usaSla) {
        return null;
    }

    const dataBase = normalizarData(dataReferencia, formatoEntrada);
    const diaFechamento = parseInt(fechamentoCalendario, 10);

    if (!dataBase || isNaN(diaFechamento) || diaFechamento <= 0) {
        return null;
    }

    const dataFechamento = dataBase.clone().startOf('month');
    if (calendarioFechaProximoMes) {
        dataFechamento.add(1, 'month');
    }

    const dia = Math.min(diaFechamento, dataFechamento.daysInMonth());
    return dataFechamento.date(dia).endOf('day').toDate();
}

export function dataInicialPermitidaParaAlteracao(
    dataInicial: Date | moment.Moment | string | null,
    usaSla: boolean,
    fechamentoCalendario: string,
    calendarioFechaProximoMes: boolean,
    dataAtual: Date | moment.Moment | string = moment(),
    formatoEntrada?: string
): boolean {
    if (!usaSla) {
        return true;
    }

    const dataInicialMoment = normalizarData(dataInicial, formatoEntrada);
    const dataAtualMoment = normalizarData(dataAtual);
    const dataFechamento = calcularDataFechamentoSlaPorMes(
        dataInicialMoment,
        usaSla,
        fechamentoCalendario,
        calendarioFechaProximoMes
    );

    if (!dataInicialMoment || !dataAtualMoment || !dataFechamento) {
        return true;
    }

    return dataAtualMoment.isSameOrBefore(moment(dataFechamento), 'day');
}

export function calcularPrimeiraDataInicialPermitida(
    dataMinima: Date | moment.Moment | string | null,
    usaSla: boolean,
    fechamentoCalendario: string,
    calendarioFechaProximoMes: boolean,
    dataAtual: Date | moment.Moment | string = moment()
): Date | null {
    const dataMinimaMoment = normalizarData(dataMinima);
    if (!dataMinimaMoment) {
        return null;
    }

    if (!usaSla) {
        return dataMinimaMoment.startOf('day').toDate();
    }

    const dataAtualMoment = normalizarData(dataAtual);
    if (!dataAtualMoment) {
        return dataMinimaMoment.startOf('day').toDate();
    }

    let dataPermitida = dataMinimaMoment.clone().startOf('day');
    const limiteBusca = dataPermitida.clone().add(60, 'months');

    while (
        dataPermitida.isSameOrBefore(limiteBusca, 'day') &&
        !dataInicialPermitidaParaAlteracao(
            dataPermitida,
            usaSla,
            fechamentoCalendario,
            calendarioFechaProximoMes,
            dataAtualMoment
        )
    ) {
        dataPermitida.startOf('month').add(1, 'month');
    }

    return dataPermitida.toDate();
}
